import { uuidModule } from "@/modules/uuid";
import type {
  AssistantSkillDeletedSyncUpdateValue,
  AssistantSkillModelData,
} from "@/store/assistant/types";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import type { IDeleteAssistantSkillOperation } from "@/store/sync/operations/types";
import type { OptimisticSyncUpdate, SyncModelData } from "@/store/sync/types";

export class DeleteAssistantSkillOperation extends BaseSyncOperation<IDeleteAssistantSkillOperation> {
  get operationKind(): "DELETE_ASSISTANT_SKILL" {
    return "DELETE_ASSISTANT_SKILL";
  }

  override get waitForPullConfirmationBeforeOptimisticCleanup(): boolean {
    return true;
  }

  public async generateOptimisticUpdates(): Promise<OptimisticSyncUpdate<SyncModelData>[]> {
    const existingSkill = await this.store.assistantSkills.getAsync(this.payload.id);
    if (!existingSkill) return [];

    const value: AssistantSkillDeletedSyncUpdateValue = {
      model_id: this.payload.id,
      model_kind: "ASSISTANT_SKILL",
      model_version: existingSkill.modelVersion,
    };
    const update = {
      optimistic_update_id: uuidModule.generate(),
      locally_committed_at: this.committedAt,
      kind: "DELETED",
      value,
    } as unknown as OptimisticSyncUpdate<AssistantSkillModelData>;
    return [update];
  }

  async triggerRecompute(): Promise<void> {
    await this.store.assistantSkills.recompute(this.payload.id);
  }
}
